import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as routeBound from '../../../route-bound'

import * as me from '../../../me'

import { Api } from './api.service'
import type { TypeParams } from './types'

/**
 * Space function collection for fetching space functions
 */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    super({
      api: ngCore.inject(Api),
      context$: ngCore.inject(routeBound.scenario.Context.TOKEN),
      identify: spaceFunction => spaceFunction.id,
      name: ec.Name.Predefined.SpaceFunction,
    })
  }
}
